export default class Configuration {
    public static BASE_URL = process.env.REACT_APP_SERVICE_ENDPOINT as string
    public static EDIT_COUNTRY() {
        const editCountry = process.env.REACT_APP_EDIT_COUNTRY as string
        return editCountry === 'TRUE'
    }
}
